import { render, staticRenderFns } from "./DeleteMaterial.vue?vue&type=template&id=0fb9a49c&"
import script from "./DeleteMaterial.vue?vue&type=script&lang=js&"
export * from "./DeleteMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports